<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Status Log</mat-panel-title>
  </mat-expansion-panel-header>
  <mat-divider></mat-divider>
  <div class="log-list">
    <table mat-table [dataSource]="logs" class="logs-list-table" aria-describedby="Site Statuses">
      <ng-container matColumnDef="oldStatus">
        <th scope="col" mat-header-cell *matHeaderCellDef>Previous Status</th>
        <td mat-cell *matCellDef="let element">{{ element.oldStatus }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th scope="col" mat-header-cell *matHeaderCellDef>New Status</th>
        <td mat-cell *matCellDef="let element">{{ element.status }}</td>
      </ng-container>
      <ng-container matColumnDef="changedBy">
        <th scope="col" mat-header-cell *matHeaderCellDef>Changed By</th>
        <td mat-cell *matCellDef="let element">
          {{ element.changedBy.email }}
        </td>
      </ng-container>
      <ng-container matColumnDef="changeDate">
        <th scope="col" mat-header-cell *matHeaderCellDef>Change Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.changeDate | date: 'shortDate' }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</mat-expansion-panel>
